<template>
<div class="">
<user-top></user-top>
<div class="millia">
<div class="ht tc mt50">修改手机号</div>
<form class="layui-form" action="">
<ul class="userInfo">
<!-- <li><input type="text" name="title" lay-verify="title" placeholder="请输入原手机号" class="layui-input"></li> -->
<li><input type="text" name="new_phone" lay-verify="title" placeholder="请输入新手机号" class="layui-input" v-model="new_phone"></li>
<li>
<div class="layui-input-inline">
<input type="text" name="sms_code" lay-verify="required" placeholder="请输入验证码" class="layui-input" v-model="sms_code">
</div>   
<button type="button" class="layui-btn ml10" @click="GetCode" :disabled="!disabled">{{getCodeTxt}}</button>
</li>
<li><button type="button" class="layui-btn layui-btn-lg layui-btn-normal" @click="ChangeTelEnter">确认修改</button></li>
</ul>
</form>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name: 'ChangeTel',
    components: {
        UserTop
    },
    data () {
        return {
            new_phone:"",
            sms_code:"",
            disabled:true,
            getCodeTxt:"获取验证码",
        }
    },
    methods: {
        GetCode:function(){
            let url = "api/sms/sendSms";
            let param = {
                type:"change_mobile",
                phone:this.new_phone
            }
            this.$ajax.get(url,param).then(function (response) {
                //console.log(response.data);
                if (response.data.status==1) {
                    //点击获取验证码倒计时
                    let time = 60;
                    let timer = setInterval(() => {
                        if(time == 0) {
                            clearInterval(timer);
                            this.disabled = true;
                            this.getCodeTxt = "获取验证码";
                        }else{
                            this.getCodeTxt =time + '秒后重试';
                            this.disabled = false;
                            time--
                        }
                    },1000);
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        ChangeTelEnter:function(){
            let url = "api/user/changeMobile";
            let param = {
                new_phone:this.new_phone,
                sms_code:this.sms_code
            }
            this.$ajax.post(url,param).then(function (response) {
                 console.log(response.data);
                if (response.data.status==1) {
                    layer.alert("手机号修改成功");
                    this.$router.push('/UserInfo');
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
    }
}
</script>
<style scoped>

</style>